import {IFormFilesInterface} from "../Shared/form-files.interface";

export type IExemptionPropertyDamagedFormSixthSection = {
    AdditionalDocuments?: Array<IFormFilesInterface>,
}

export const ExemptionPropertyDamagedFormSixthSectionInterface = (): IExemptionPropertyDamagedFormSixthSection => ({
    AdditionalDocuments: undefined
})